module.exports = __webpack_public_path__ + "img/full03.351b09c0.svg";